import { html } from "lit";
import { customElement } from "lit/decorators.js";

import "ui-components/form-elements/input/wow-input";
import "ui-components/collapsible-section/collapsible-section";

import { styles } from "./live-event-tickets-access.css";
import { SignalElement, inject } from "ui-common/di";
import type { ILiveEventFormState, ILiveEventFormService } from "ui-common/services/live-event-form/types";
import { MAX_PRICE_LIMIT } from "ui-common/form/validators/live-event-validators";
import { numericKeydown, handleFormInput, handleFormBlur } from "ui-common/form/form-utils";
import { t } from "../../../translations/i18n";

@customElement("live-event-tickets-access")
export class LiveEventTicketsAccess extends SignalElement {
  static override styles = styles;

  @inject<ILiveEventFormState>("liveEventFormState")
  private state!: ILiveEventFormState;

  @inject<ILiveEventFormService>("liveEventFormService")
  private service!: ILiveEventFormService;

  override render() {
    const formData = this.state.formData.get();
    const errors = this.state.validationErrors.get();

    return html`
      <wow-collapsible-section
        collapsible
        expanded
        header=${t("createLiveEventPage.ticketsAccess")}
        subtitle=${t("createLiveEventPage.ticketsAccessSubtitle")}
      >
        <div class="form-section">
          <div class="form-row">
            <wow-input
              label=${t("createLiveEventPage.pricePerTicket")}
              type="number"
              inputmode="decimal"
              prefix="€"
              min="0.50"
              max="${MAX_PRICE_LIMIT}"
              step="0.01"
              .value=${formData.feeEuros}
              error-message=${errors.feeEuros || ""}
              @input=${(e: Event) => handleFormInput(this.service, "feeEuros", e)}
              @blur=${() => handleFormBlur(this.service, "feeEuros")}
            ></wow-input>
            <wow-input
              label=${t("createLiveEventPage.maxAttendees")}
              type="number"
              inputmode="numeric"
              suffix=${t("createLiveEventPage.tickets")}
              step="1"
              .value=${formData.maxAttendees}
              error-message=${errors.maxAttendees || ""}
              @input=${(e: Event) => handleFormInput(this.service, "maxAttendees", e)}
              @blur=${() => handleFormBlur(this.service, "maxAttendees")}
              @keydown=${numericKeydown}
            ></wow-input>
          </div>
        </div>
      </wow-collapsible-section>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "live-event-tickets-access": LiveEventTicketsAccess;
  }
}
